import { Outlet } from 'react-router-dom';

function Companies(){
    return(
        <Outlet/>
    );
}

export default Companies;
  